exports = module.exports = require("../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-0260f1d2].el-breadcrumb__separator,[data-v-0260f1d2].el-breadcrumb__inner{color:#444}", ""]);

// exports
